import React from 'react';
import scaleSize from 'utils/scale-size';

export default () => {
  return (
    <svg
      width={scaleSize(48)}
      height={scaleSize(48)}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="fill-change"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 16C34 17.6569 32.6569 19 31 19C29.3431 19 28 17.6569 28 16C28 14.3431 29.3431 13 31 13C32.6569 13 34 14.3431 34 16ZM36.811 17.5C36.1449 20.0878 33.7958 22 31 22C28.2042 22 25.8551 20.0878 25.189 17.5H24H21.2368H9C8.17157 17.5 7.5 16.8284 7.5 16C7.5 15.1716 8.17157 14.5 9 14.5H21.2368H24H25.189C25.8551 11.9122 28.2042 10 31 10C33.7958 10 36.1449 11.9122 36.811 14.5H37H38.6316H39C39.8284 14.5 40.5 15.1716 40.5 16C40.5 16.8284 39.8284 17.5 39 17.5H38.6316H37H36.811ZM21 32C21 33.6569 19.6569 35 18 35C16.3431 35 15 33.6569 15 32C15 30.3431 16.3431 29 18 29C19.6569 29 21 30.3431 21 32ZM23.811 33.5C23.1449 36.0878 20.7958 38 18 38C15.2042 38 12.8551 36.0878 12.189 33.5H11H10.6316H9C8.17157 33.5 7.5 32.8284 7.5 32C7.5 31.1716 8.17157 30.5 9 30.5H10.6316H11H12.189C12.8551 27.9122 15.2042 26 18 26C20.7958 26 23.1449 27.9122 23.811 30.5H24H36.2368H39C39.8284 30.5 40.5 31.1716 40.5 32C40.5 32.8284 39.8284 33.5 39 33.5H36.2368H24H23.811Z"
        fill="#9F9F9F"
      />
    </svg>
  );
};
